export default __webpack_public_path__ + "static/media/stignatius.b5a071dd.jpg";